import styled from "styled-components";


export const Wrapper = styled.div`
  background-color: darkgray;
  padding: 1.5rem;
  color: #ffffff;
  width: 15rem;
  font-size: 1.3rem;
  text-transform: uppercase;
  margin: 0 2rem 2rem 1rem;
  border-radius: .3rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;

  &:hover {
    background-color: #EF534F;
    cursor: pointer;
  }

`;
